"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TextProperties", {
  enumerable: true,
  get: function get() {
    return _TextProperties["default"];
  }
});

var _TextProperties = _interopRequireDefault(require("./TextProperties"));